import React, { ComponentProps } from 'react';
import OverviewCard from './OverviewCard';
import ErrorBanner from '../../ui/ErrorBanner';

type Props = {
  overview?: Array<ComponentProps<typeof OverviewCard>>;
  isLoading: boolean;
  isError: boolean;
  refetch?: () => void;
};

export default function DashboardOverview({
  overview,
  isLoading,
  isError,
  refetch,
}: Props) {
  return (
    <>
      {isLoading ? (
        <div className="w-full h-24 rounded-md bg-white border border-gray-100 animate-pulse shadow-sm" />
      ) : isError || !overview?.length ? (
        <ErrorBanner retry={refetch} message="Something went wrong" />
      ) : (
        <div className="grid min-[520px]:grid-cols-2 md:grid-cols-4 gap-4">
          {overview.map((overview, index) => (
            <OverviewCard {...overview} key={index} />
          ))}
        </div>
      )}
    </>
  );
}
